/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-breadcrumb.html";
import {
  StringService,
  SitesSessionStorageService,
  events,
  BreadcrumbUtil,
  util
} from "@nuskin/ns-util";
import "@nuskin/ns-style-elements";

/**
 * The ns-breadcrumb should be used for
 *
 * <h1>breadcrumb</h1>
 * <demo-snippet>
 *   <template>
 *     <ns-breadcrumb class="demoElement"></ns-breadcrumb>
 *   </template>
 * </demo-snippet>
 *
 */

const KEY_BREADCRUMB_BACK = "breadcrumbBack";

class NsBreadcrumb extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
    this.setCommonStrings();
    this.checkIfPDP();
  }

  static get is() {
    return "ns-breadcrumb";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * Determines if the breadcrumbs or the back button should be shown
       */
      back: {
        type: Boolean,
        value: SitesSessionStorageService.removeItem(KEY_BREADCRUMB_BACK),
        reflectToAttribute: true
      },
      /**
       * Array of breadcrumb objects that each have the keys "name" & "href"
       * [ { "name": "Shop", "href": "/products.html" }, { "name": "Shop All Categories", "href": "/products/shop/shop_all.html" } ]
       */
      breadcrumbList: {
        type: Array,
        value: []
      },
      /**
       * Shows the first breadcrumb in the breadcrumbList
       * Defaults to false
       */
      showTopLevel: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * Translation strings
       * { "back": "Back" }
       */
      translations: {
        type: Object,
        value: {
          backText: "Back"
        }
      }
    };
  }

  /**
   * On click event for Back
   */
  navBack(e) {
    this.sendAnalytics({ name: "History Back" });
    history.back();
  }

  /**
   * On click event for any other breadcrumb
   */
  navBreadcrumb(e) {
    this.sendAnalytics(e.model.item);
  }

  /**
   * Checks if previous page was the legacy category page
   * TODO: Deprecate in conjunction with the legacy category page
   */
  checkIfPDP() {
    let isPDP = util.getCurrentPageName().toLowerCase() === "product";
    if (
      document.referrer.includes("/products") &&
      isPDP &&
      !document.referrer.includes("content/login/corporate")
    ) {
      BreadcrumbUtil.getBreadcrumbFromHistory().then((data) => {
        this.set("breadcrumbList", data);
        this._setMobileState();
      });
    } else if (
      isPDP &&
      (document.referrer.length === 0 ||
        !this.breadcrumbList ||
        this.breadcrumbList.length <= 1)
    ) {
      this.back = true;
    }
  }

  /**
   * Sets common strings from StringService
   */
  setCommonStrings() {
    StringService.getStrings([{ key: "backText", dflt: "Back" }]).then(
      (backText) => {
        this.set("translations", backText);
        this._setMobileState();
      }
    );
  }

  /**
   * Sends which link was clicked to analytics
   */
  sendAnalytics(navData) {
    events.publish(events.global.BREADCRUMB, navData);
  }

  /**
   * Sets mobile state so only last page displays with back arrow
   */
  _setMobileState() {
    if (
      util.MobileUtils.isMobile() &&
      this.breadcrumbList &&
      this.breadcrumbList.length > 1
    ) {
      this.back = true;
      this.set(
        "translations.backText",
        this.breadcrumbList[this.breadcrumbList.length - 2].name
      );
    }
  }

  /**
   * Checks to see if the item has a valid href
   */
  _hasValidHref(item) {
    if (item && item.href && item.href.length > 0) return true;
    else return false;
  }
}
customElements.define(NsBreadcrumb.is, NsBreadcrumb);
